import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const Frequencies = (props: Props) => (
  <FilterAutocomplete
    label="Frequencies"
    fieldName={'frequencies'}
    fieldPath={'productInformation.frequencies'}
  />
)
